const prefix = ''
export const DevopsApi = {
  // 检查是否授权过
  checkDevopsAuth: `${prefix}/api/devops/deploy/check-devops-auth`,
  // 保存devops系统授权的令牌
  saveDevopsAuth: `${prefix}/api/devops/deploy/save-devops-auth`,
  // 查询dev发版环境
  searchEnvList: `${prefix}/api/devops/deploy/search-env-list`,
  // 查询dev发版模块
  searchModuleList: `${prefix}/api/devops/deploy/search-module-list`,
  // 查询dev发版工程
  searchProjectList: `${prefix}/api/devops/deploy/search-project-list`,
  // 查询dev change列表
  searchChangeList: `${prefix}/api/devops/deploy/search-dev-change-list`,
  // 触发dev 增量发版
  applyDevDeploy: `${prefix}/api/devops/deploy/apply-dev-deploy`,
  // 查询pre change列表
  searchPreChangeList: `${prefix}/api/devops/deploy/search-pre-change-list`,
  // 触发pre 增量发版
  applyPreDeploy: `${prefix}/api/devops/deploy/apply-pre-deploy`
}
